// https://github.com/choojs/nanobus#readme

import eventbus from 'nanobus'
export default eventbus();